import React from 'react';
import AlertDetail from '../../ns/alertDetail';
import { ROUTE_AMLS_SMART_SCREENING } from '../../constants/globalConstants';
import BreadCrumb from '../../../components/BreadCrumb';
import {
  BackButtonContainer,
  LeftHeader,
  PageHeader,
  StyledBreadCrumbDiv
} from './styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

const AlertDetails = ({ match, history }) => {
  const { alertId, tabId } = match.params;
  const path = `${ROUTE_AMLS_SMART_SCREENING}/on-demand-screening?tabId=${tabId}`;

  return (
    <>
      <PageHeader style={{ padding: 0 }}>
        <StyledBreadCrumbDiv>
          <BreadCrumb
            crumbs={[
              {
                label: 'On Demand Screening',
                linkTo: path
              },
              { label: 'Alert Details' }
            ]}
          />
          <LeftHeader>
            <BackButtonContainer onClick={() => history.push(path)}>
              <FontAwesomeIcon icon={faArrowLeft} color="#31394D" />
            </BackButtonContainer>
            Alert Details
          </LeftHeader>
        </StyledBreadCrumbDiv>
      </PageHeader>
      <AlertDetail alertId={alertId} isEmbedded isFromNameScreening />
    </>
  );
};

export default AlertDetails;
